export const SET_EMAILMODELS = "SET_EMAILMODELS"
export const SET_EMAILMODELTEMPLATEVARIABLES = "SET_EMAILMODELTEMPLATEVARIABLES";
export const SET_EMAILENGINEVARIABLEKEYS = "SET_EMAILENGINEVARIABLEKEYS";